import * as ko from "knockout";
import AbstractInput from "./AbstractInput";
import {getNextId} from "../../util/misc";
import {IDynamicVariableTextInputParams} from "./index";
import {global} from "../../appContext";
import {nsFa} from "../fa/fn";
import i = nsFa.i;
import text_areaHtml from './text-area.html?raw';

export let template = text_areaHtml;

export class viewModel extends AbstractInput {
    private componentId = 'dynamicExpressionTextArea_' + getNextId()
    private numLines: KnockoutObservable<number> = ko.observable(10)
    private el_linenumbers!: HTMLDivElement;
    private el_textareaStyles!: CSSStyleDeclaration;
    private readonly canOpenInDialog: boolean;

    constructor(protected override params: IDynamicVariableTextInputParams) {
        super(params);
        this.canOpenInDialog = params.canOpenInDialog ?? false
    }

    protected override init() {
        super.init()
        const el = document.querySelector(`#${this.componentId} .line-numbers`)
        if (!el) {
            return;
        }
        this.el_linenumbers = el as HTMLDivElement
        this.updateStyles()
        this.updateNumberOfLines(this.rows);
    }

    protected override onResize() {
        super.onResize();
        this.updateStyles()
        const rect = this.srcEl.getBoundingClientRect();
        this.el_linenumbers.style.height = `${rect.height}px`;
        this.updateNumberOfLines();
    }

    private updateNumberOfLines(numLines?: number) {
        const lineHeight = parseFloat(this.el_textareaStyles.lineHeight)
        const lines = numLines ?? this.srcEl.scrollHeight / lineHeight
        this.numLines(Math.ceil(lines))
    }

    private updateStyles() {
        this.el_textareaStyles = window.getComputedStyle(this.srcEl);
        [
            'fontFamily',
            'fontSize',
            'fontWeight',
            'letterSpacing',
            'lineHeight',
            'padding',
        ].forEach((prop: string) => {
            const value = this.el_textareaStyles[prop as any];
            if (value !== undefined) {
                this.el_linenumbers.style[prop as any] = value;
            }
        });
    }

    protected override onEvent(e: Event | null = null) {
        if (e?.type == 'input') {
            this.updateNumberOfLines();
        }
        super.onEvent(e);
    }

    protected onScroll() {
        this.updateNumberOfLines();
        this.el_linenumbers.scrollTop = this.srcEl.scrollTop;
    }

    private onEditExpressionClick() {
        global.dialogManager.addComponent({
            title: `${i('fa-pencil-ruler')} ((edit expression))`,
            content: {
                name: 'component/dynamic-variable/dialog/builder',
                params: {
                    expression: this.expression,
                    objectTypeId: ko.unwrap(this.params.objectTypeId),
                    objectTypeIds: ko.unwrap(this.params.objectTypeIds),
                },
            }
        });
    }

    protected override updateShadowStyle() {
        super.updateShadowStyle()
        this.shadow.style.whiteSpace = "pre-wrap";
    }

}


